import React, { useEffect, useContext } from "react";
import styled from "@emotion/styled";
import List from "../Components/chat/List";
import Messages from "../Components/chat/Messages";
import { ChatContext } from "../context/chat";

const Wrapper = styled.div`
  display: flex;
  height: calc(100% - 90px);
  background:#eeeff0;
`;

const Chats = () => {
  const { getActiveChats } = useContext(ChatContext)

  useEffect(() => {
    getActiveChats()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
  
    <Wrapper>
      <List />
      <Messages />
    </Wrapper>
  )
};

export default Chats;
